<template>
  <div>
    <el-form class="search_form" size="mini" :inline="true">
      <!--搜索框-->
<!--      <el-col :span="3">
        <el-form-item>
          <el-select placeholder="运营商" clearable v-model="operatorId">
            <el-option
              v-for="item in operatorHisList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>-->
      <el-col :span="3">
        <el-form-item>
          <el-input
            v-model="ruleName"
            placeholder="费率名称"
            clearable
          ></el-input>
        </el-form-item>
      </el-col>
<!--      <el-col :span="1.5">
        <el-form-item>
          <el-button size="mini" type="primary" @click="reset">清空</el-button>
        </el-form-item>
      </el-col>-->
      <el-col :span="1.5">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="check"
            >查询
          </el-button>
        </el-form-item>
      </el-col>
      <el-col :span="2.5" class="diy-class">
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            class="el-btn"
            v-if="checkPermission(['bee:res:rate:saveBillingRules'])"
            @click="addPOF"
          >
            新增费率
          </el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <el-table
      :data="list"
      stripe
      style="width: 100%"
      ref="list"
      border
      v-loading="Loading"
    >
      <af-table-column prop="id" label="费率ID"></af-table-column>
      <af-table-column prop="ruleName" label="费率名称"></af-table-column>
      <af-table-column prop="operatorName" label="所属运营商"></af-table-column>
      <af-table-column prop="amountTop" label="上限(元)">
        <template #default="{ row }">
          {{ row.haveAmountTopCode === "Y" ? row.amountTop : "无上限" }}
        </template>
      </af-table-column>
      <af-table-column
        prop="reduceTime"
        label="减免时长(分钟)"
      ></af-table-column>
      <af-table-column prop="operatorName" label="费率价格">
        <template #default="{ row }">
          <div v-for="(item, index) in row.timeSlotList" :key="index">
            {{ item.showName }}
          </div>
        </template>
      </af-table-column>
      <af-table-column label="操作" width="200px" fixed="right">
        <template #default="{ row }">
          <el-button
            size="mini"
            v-if="checkPermission(['bee:res:rate:updateBillingRules'])"
            @click="editList(row)"
            >编辑
          </el-button>
<!--          <el-button
            size="mini"
            type="danger"
            v-if="checkPermission(['bee:res:rate:deleteRate'])"
            @click="deleteList(row.id)"
            >删除
          </el-button>-->
        </template>
      </af-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 15px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <addPOF
      ref="forms"
      :operatorHisList="operatorHisList"
      :showDialog.sync="showDialog"
      :params.sync="params"
    ></addPOF>
  </div>
</template>


<script>
import addPOF from "./addPOF.vue";
import OccupancyFeeApi from "../../../api/OccupancyFeeApi";
export default {
  name: "PileOccupationFee",
  components: {
    addPOF,
  },
  data() {
    return {
      pageSize: 10, // 页容量
      currentPage: 1, // 页码
      total: 1, // 总数据量
      operatorId: "", // 运营商id
      ruleName: "", // 费率名称
      showDialog: false, // 新增费率弹窗
      list: [], // 列表数据
      Loading: false, // 加载
      params: "",
    };
  },
  props: {
    operatorHisList: {
      type: Array,
      required: true,
    },
  },
  created() {
    // 调用获取列表数据
    this.operatorId = sessionStorage.getItem('operatorId');
    this.getBillingRules();
  },

  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this.operatorId = sessionStorage.getItem('operatorId');
        this.getBillingRules()
      },
      deep: true
    }
  },



  methods: {
    // 编辑
    editList(e) {
      let param = {
        id: e.id,
        operatorId: e.operatorId,
        titleName: "编辑",
      };
      this.params = JSON.stringify(param);
      this.showDialog = true;
    },
    // 删除列表数据
    deleteList(id) {
      console.log(id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          OccupancyFeeApi.delete(id).then((res) => {
            // console.log(res, "删除");
            if (res.code === 0) {
              this.$message.success("删除成功");
              this.getBillingRules();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 获取列表数据
    getBillingRules() {
      this.Loading = true;
      let params = {
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        t: {
          operatorId: this.operatorId,
          ruleName: this.ruleName,
        },
      };
      // console.log(params, "参数");
      OccupancyFeeApi.getBillingRules(params).then((res) => {
        // console.log(res.data, "fenfenfnenfenfnenfnen");
        this.total = res.data.total;
        this.list = res.data.records;
        this.Loading = false;
      });
    },
    // 新增费率
    addPOF() {
      let param = {
        titleName: "新增",
      };
      this.params = JSON.stringify(param)
      this.showDialog = true;
    },
    // 清空搜索数据
    reset() {
      this.operatorId = "";
      this.ruleName = "";
    },
    // 查询数据
    check() {
      (this.pageSize = 10), (this.currentPage = 1), this.getBillingRules();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBillingRules();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBillingRules();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/pileOccupation/PileOccupationFee.vue